export default {
    headerModuleHeight: '60px',
    headerModuleHeightSticky: '54px',
    oneHeaderModuleHeight: '56px',
    oneHeaderModuleHeightWithS2CBanner: '100px',
    notificationBarTopHeight: {
        mobile: '100px',
        tablet: '148px',
        desktop: '50px',
        wideScreens: '60px',
    },
    desktopPagePadding: '15px',
    tabletPagePadding: '30px',
    zIndexSkuDiverActionMenu: 200,
    zIndexShopToClubDOI: 103,
    zIndexShopToClubRegistration: 102,
    zIndexPopUpOverlay: 101,
    newHeaderTabsHeight: '46px',
    zindexUserSideNav: 60,
    zindexCategoryNav: 50,
    zindexHeaderClubTab: 40,
    zindexHeaderBarBanner: 41,
    zindexOneHeaderShadow: 40,
    zindexOneHeaderNavBar: 41,
    zindexOneHeader: 42,
    zindexHeaderTopBar: 30,
    zIndexNavigationFlyout: 29,
    zIndexContentOverlay: 28,
    zIndexBelowContentOverlay: 27, // about time we start discussing a better way to manage these z-indexes for bella
    zindexHeaderStickyIconBar: 20,
    zindexOverlayLoader: 15,
    zIndexDesktopDropDown: 5,
    zIndexHideClubTabRightShadow: 3,
    zIndexProductSpinner: 2,
    zIndexSliderArrows: 2,
    zIndexNavInfoSection: 1,
    zIndexProductGridBadges: 1,
    zIndexSmartBanner: 1,
};
